// Label per il form
export const REQUIRED_FIELD = "ld.form.requiredField";
export const NOME_PLACEHOLDER = "ld.form.nomePlaceholder";
export const COGNOME_PLACEHOLDER = "ld.form.cognomePlaceholder";
export const CF_PLACEHOLDER = "ld.form.cfPlaceholder";
export const EMAIL_LABEL = "ld.form.emailLabel";
export const EMAIL_PLACEHOLDER = "ld.form.emailPlaceholder";
export const EMAIL_ERROR = "ld.form.emailError";
export const CELLULARE_LABEL = "ld.form.cellulareLabel";
export const CELLULARE_PLACEHOLDER = "ld.form.cellularePlaceholder";
export const CELLULARE_ERROR = "ld.form.cellulareError";
export const CELLULARE_ERROR_LENGTH = "ld.form.cellulareErrorLength";
export const ISTITUTO_LABEL = "ld.form.istitutoLabel";
export const ISTITUTO_PLACEHOLDER = "ld.form.istitutoPlaceholder";
export const INCARICO_LABEL = "ld.form.incaricoLabel";
export const INCARICO_PLACEHOLDER = "ld.form.incaricoPlaceholder";
export const TOOLTIP_DICHIARAZIONE = "ld.form.tooltipDichiarazione";
export const BUTTON_DICHIARAZIONE = "ld.form.buttonDichiarazione";
export const AUTOCERTIFICAZIONE_PLACEHOLDER = "ld.form.autocertificazionePlaceholder";
export const PRIVACY_PLACEHOLDER = "ld.form.privacyPlaceholder";
export const NEWSLETTER_PLACEHOLDER = "ld.form.newsletterPlaceholder";
export const CAMPI_OBBLIGATORI_LABEL = "ld.form.campiObbligatori";
export const SALVA = "ld.form.salva";
export const CHIUDI = "ld.form.chiudi";
export const ACCETTA = "ld.form.accetta";
export const CANCELLA = "ld.form.cancella";
export const AVVISO_UTENTE_DISABILITATO = "Id.form.utenteDisabilitato";
export const NO_DATA = "ld.form.noData";
// Label per l'errore d'inserimento
export const INSRIMENTO_FAILED = "ld.erroreInserimento.inserimentoFallito";
export const INSRIMENTO_FAILED_HELP = "ld.erroreInserimento.inserimentoFallitoHelp";

// Label per il modale di utente non autenticato
export const USER_NOT_AUTHENTICATED_LABEL = "ld.notAuth.userNotAuthenticated";
export const ACCEDI_LABEL = "ld.notAuth.accedi";

// Label per il modale di errore gateway
export const GATEWAY_ERROR_INFO = "ld.gatewayError.info";
export const GATEWAY_ERROR_INSTRUCTIONS = "ld.gatewayError.instruction";
export const GATEWAY_ERROR_HELP = "ld.gatewayError.help";
